__turbopack_context__.v({
  "text-area-box": "_093CuG_text-area-box",
  "text-area-input": "_093CuG_text-area-input",
});
